// import React, { useEffect, useRef } from 'react'
// import { confirmRemoveLicenseModal } from '../../../assets/styles/ClientsStyles/confirmRemoveLicenseModal' // Adjust the path
// import { RootState } from '../../../store/store'
// import { useSelector } from 'react-redux'
// import useCustomStyles from '../../../hooks/useCustomStyles'

// interface ConfirmRemoveLicenseModalProps {
//   isOpen: boolean
//   onCancel: () => void
//   onConfirm: () => void
// }

// const ConfirmRemoveLicenseModal: React.FC<ConfirmRemoveLicenseModalProps> = ({
//   isOpen,
//   onCancel,
//   onConfirm,
// }) => {
//   const modalRef = useRef<HTMLDivElement>(null)
//   const { theme } = useSelector((state: RootState) => state.theme_slice)
//   const classes = useCustomStyles(confirmRemoveLicenseModal, theme)

//   useEffect(() => {
//     const handleOutsideClick = (event: MouseEvent) => {
//       if (
//         modalRef.current &&
//         !modalRef.current.contains(event.target as Node)
//       ) {
//         onCancel()
//       }
//     }

//     if (isOpen) {
//       document.addEventListener('mousedown', handleOutsideClick)
//     }

//     return () => {
//       document.removeEventListener('mousedown', handleOutsideClick)
//     }
//   }, [isOpen, onCancel])

//   if (!isOpen) return null

//   return (
//     <div className={classes.backdrop}>
//       <div ref={modalRef} className={classes.modalContainer}>
//         <h3 className={classes.title}>
//           Are you sure you want to <br /> remove this licence?
//         </h3>
//         <p className={classes.description}>
//           The advisor record will also be deleted,
//           <br />
//           and the licence will be available to assign <br />
//           to a new client or advisor
//         </p>

//         <div className={classes.actionContainer}>
//           <button className={classes.cancelButton} onClick={onCancel}>
//             Cancel
//           </button>
//           <button className={classes.confirmButton} onClick={onConfirm}>
//             Remove Licence
//           </button>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default ConfirmRemoveLicenseModal

import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import useCustomStyles from "../../../hooks/useCustomStyles";
import { confirmModalStyles } from "../../../assets/styles/ClientsStyles/confirmModalStyles"; // Renamed styles file

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmButtonColor?: string;
  cancelButtonColor?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmButtonColor,
  cancelButtonColor,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const { theme } = useSelector((state: RootState) => state.theme_slice);
  const classes = useCustomStyles(confirmModalStyles, theme);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={classes.backdrop}>
      <div ref={modalRef} className={classes.modalContainer}>
        <h3 className={classes.title}>{title}</h3>
        <div className={classes.description}>{description}</div>

        <div className={classes.actionContainer}>
          <button
            className={classes.cancelButton}
            onClick={onClose}
            style={
              cancelButtonColor ? { backgroundColor: cancelButtonColor } : {}
            }
          >
            {cancelText}
          </button>
          <button
            className={classes.confirmButton}
            onClick={onConfirm}
            style={
              confirmButtonColor ? { backgroundColor: confirmButtonColor } : {}
            }
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
